var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeThumb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 133.66 186.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1-th{fill:#ff3b83;}.cls-2-th{fill:#ffc300;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icone_Resume_new",
    "data-name": "Icone Resume new"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_3",
    "data-name": "Livello 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1-th",
    d: "M116.44,159.47a17.21,17.21,0,1,1,17.22-17.21A17.23,17.23,0,0,1,116.44,159.47Zm0-27.59a10.38,10.38,0,1,0,10.39,10.38A10.39,10.39,0,0,0,116.44,131.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-th",
    d: "M116.44,131.88a17.21,17.21,0,1,1,17.22-17.22A17.24,17.24,0,0,1,116.44,131.88Zm0-27.59a10.38,10.38,0,1,0,10.39,10.37A10.39,10.39,0,0,0,116.44,104.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-th",
    d: "M116.44,187a17.21,17.21,0,1,1,17.22-17.21A17.23,17.23,0,0,1,116.44,187Zm0-27.59a10.38,10.38,0,1,0,10.39,10.38A10.4,10.4,0,0,0,116.44,159.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2-th",
    d: "M110.23,186.92H36.4A36.44,36.44,0,0,1,0,150.52V0H8.6A28.86,28.86,0,0,1,37.43,28.82V70.07h80V76.9H30.6V28.82a22,22,0,0,0-22-22H6.83V150.52A29.6,29.6,0,0,0,36.4,180.09h73.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-th",
    d: "M116.44,187a17.21,17.21,0,1,1,17.22-17.21A17.23,17.23,0,0,1,116.44,187Zm0-27.59a10.38,10.38,0,1,0,10.39,10.38A10.4,10.4,0,0,0,116.44,159.4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1-th",
    x: 61.26,
    y: 180.09,
    width: 55.18,
    height: 6.83
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1-th",
    d: "M116.44,104.35a17.21,17.21,0,1,1,17.22-17.2A17.22,17.22,0,0,1,116.44,104.35Zm0-27.59a10.38,10.38,0,1,0,10.39,10.39A10.4,10.4,0,0,0,116.44,76.76Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeThumb);
export default __webpack_public_path__ + "static/media/home-thumb.0834d1e5efdfcff4db4aebeb7d39193d.svg";
export { ForwardRef as ReactComponent };